import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import QrReader from 'react-qr-reader'

import Modal from 'components/modal/Modal'

import Typography from '@material-ui/core/Typography'

import { useDispatch } from 'react-redux'
import * as actions from 'redux/actions'

import translator from 'utility/translator'

const useStyles = makeStyles((theme) => ({
  text: {
    textAlign: 'center',
  },
}))

const QRReader = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const handleScan = payload => {
    if (payload)
      dispatch({ type: actions.READ_QR, payload })
  }

  const handleError = err => {
    console.error(err)
  }

  return (
    <Modal props={{}}>
      <Typography variant='h4'>{translator.fromLabel('qrReader_title')}</Typography>
      <Typography variant='h6' className={classes.text}>{translator.fromLabel('qrReader_text')}</Typography>
      <QrReader
        delay={1000}
        onError={handleError}
        onScan={handleScan}
        style={{ width: '100%' }}
      />
    </Modal>
  )
}

export default QRReader
